import { Injectable } from '@angular/core';
import { sampleMitiData } from './data/miti-data';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { map, Observable } from 'rxjs';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';

@Injectable({
    providedIn: 'root',
})
export class GrantDetailsService {
    mitiData: any = sampleMitiData;
    constructor(private _apiService: ApiService) {}

    getMitiData(slug: string): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.GRANTS).pipe(
            map((data: any) => {
                if (data?.[0]?.products) {
                    // Find the specific product
                    const product = data[0].products.find((item: any) => {
                        const tempSlug = item.productName
                            ?.replaceAll('(', '')
                            .replaceAll(')', '')
                            .replaceAll(' ', '-')
                            .toLowerCase();
                        return slug === tempSlug;
                    });

                    // Extract unique images
                    const uniqueImages = Array.from(
                        new Set(data[0].products.map((item: any) => item.image))
                    );

                    return { product, images: uniqueImages };
                }

                return { product: null, images: [] };
            })
        );
    }
}
